import { useState } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { KeyRound, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';

export default function CambioPasswordDialog() {
  const { user, logout } = useAuth();
  const [attuale, setAttuale] = useState('');
  const [nuova, setNuova] = useState('');
  const [conferma, setConferma] = useState('');
  const [saving, setSaving] = useState(false);

  const obbligatorio = !!user?.must_change_password;
  if (!obbligatorio) return null;

  const salva = async () => {
    if (nuova !== conferma) { toast.error('Le due password non coincidono'); return; }
    setSaving(true);
    try {
      await api.post('/auth/change-password', { password_attuale: attuale, password_nuova: nuova });
      toast.success('Password aggiornata: accedi con la nuova password');
      setTimeout(logout, 1200);
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore nel cambio password'); }
    setSaving(false);
  };

  return (
    <Dialog open>
      <DialogContent className="max-w-md [&>button]:hidden" data-testid="cambio-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="w-4 h-4 text-brand" />Imposta la tua password</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-xs text-slate-500">
            Benvenuto {user.full_name}. Per motivi di sicurezza devi sostituire la password iniziale
            prima di accedere alla cartella clinica.
          </p>
          <div><Label className="text-xs">Password attuale *</Label>
            <Input type="password" value={attuale} onChange={e => setAttuale(e.target.value)} data-testid="pwd-attuale-input" />
          </div>
          <div><Label className="text-xs">Nuova password * (almeno 8 caratteri, con lettere e numeri)</Label>
            <Input type="password" value={nuova} onChange={e => setNuova(e.target.value)} data-testid="pwd-nuova-input" />
          </div>
          <div><Label className="text-xs">Conferma nuova password *</Label>
            <Input type="password" value={conferma} onChange={e => setConferma(e.target.value)} data-testid="pwd-conferma-input" />
          </div>
          <div className="flex items-center justify-between pt-1">
            <button onClick={logout} className="text-xs text-slate-400 hover:text-slate-600" data-testid="pwd-logout-btn">Esci</button>
            <Button onClick={salva} disabled={saving || !attuale || nuova.length < 8} className="bg-brand hover:bg-brand-dark text-white" data-testid="pwd-salva-btn">
              <ShieldCheck className="w-3.5 h-3.5 mr-1" />{saving ? 'Salvataggio...' : 'Imposta password'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
